import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import PhotoPlaceholder from "../components/PhotoPlaceholder";
import Seo from "../components/Seo";
import { Reveal } from "../components/Motion";
import { SERVICES } from "../data/site";

export default function Services() {
  return (
    <div data-testid="services-page" className="pt-28 bg-white">
      <Seo
        title="Deck & Outdoor Living Services | Zarco's Decks — North Georgia"
        description="Custom decks, TimberTech composite & PVC decking, wood decks, covered porches, stairs & railings across Rome, Cartersville, Metro Atlanta and North Georgia. Free estimate."
      />
      <section className="px-6 md:px-12 lg:px-20 py-20 md:py-24">
        <SectionHeading
          as="h1"
          overline="Our Services"
          title="From a single board to a full outdoor living build."
          subtitle="Every Zarco's Decks service is delivered by our own family crew across Metro Atlanta and North Georgia — no subcontracted surprises. Quality, schedule, and finish stay under one roof."
        />
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-20 md:pb-28 space-y-24 md:space-y-32">
        {SERVICES.map((s, idx) => {
          const isReverse = idx % 2 === 1;
          return (
            <Reveal
              key={s.slug}
              data-testid={`service-${s.slug}`}
              className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center"
            >
              <div className={`lg:col-span-7 ${isReverse ? "lg:order-2" : ""}`}>
                {s.photo ? (
                  <div className="img-hover img-spotlight aspect-[16/10]" data-testid={`service-photo-${s.slug}`}>
                    <img
                      src={s.photo}
                      alt={s.imageLabel || s.title}
                      className="w-full h-full object-cover"
                      style={{ objectPosition: s.focal || "center" }}
                      loading="lazy"
                    />
                  </div>
                ) : (
                  <PhotoPlaceholder
                    label={s.imageLabel || s.title}
                    sublabel="Add real project photo"
                    aspect="16/10"
                    variant={idx % 2 === 0 ? "dark" : "wood"}
                    testId={`service-photo-${s.slug}`}
                  />
                )}
              </div>
              <div className={`lg:col-span-5 ${isReverse ? "lg:order-1" : ""}`}>
                <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#99582A]">
                  0{idx + 1} — Service
                </p>
                <h3 className="font-display text-3xl md:text-4xl tracking-tight font-medium mt-4 text-[#111]">
                  {s.title}
                </h3>
                <p className="mt-5 text-[#4A4A4A] leading-relaxed text-base md:text-lg">
                  {s.description}
                </p>
                <ul className="mt-6 space-y-3 text-[#111]">
                  {[
                    "Free on-site consultation",
                    "Detailed written estimate",
                    "Workmanship warranty",
                  ].map((f) => (
                    <li key={f} className="flex items-center gap-3 text-sm">
                      <Check size={16} className="text-[#99582A]" strokeWidth={2} /> {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  data-testid={`service-cta-${s.slug}`}
                  className="inline-flex items-center gap-3 mt-8 bg-[#111] text-white hover:bg-[#99582A] transition-colors px-7 py-3.5 font-semibold tracking-wide"
                >
                  Get Your Free Estimate <ArrowRight size={16} />
                </Link>
              </div>
            </Reveal>
          );
        })}
      </section>

      <section className="bg-[#FBF8F3] px-6 md:px-12 lg:px-20 py-20 md:py-24 border-t border-[#E7E2D9]">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-8">
            <h2 className="font-display text-4xl md:text-5xl tracking-tight font-medium text-[#111]">
              Don't see your project? We probably build it.
            </h2>
            <p className="mt-4 text-[#4A4A4A] max-w-2xl">
              Pool decks, ADA-compliant ramps, fire-pit landings, hot tub
              platforms — if it's wood, composite, or outdoor structural,
              let's talk.
            </p>
          </div>
          <div className="lg:col-span-4 flex lg:justify-end">
            <Link
              to="/contact"
              data-testid="services-cta-free-estimate-btn"
              className="bg-[#111] text-white hover:bg-[#99582A] transition-colors px-8 py-4 font-semibold tracking-wide inline-flex items-center gap-3"
            >
              Get Your Free Estimate <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
